
<div class="filter-input-element">
  <nz-select 
    [(ngModel)]="value"
    style="width: 100%"
    (ngModelChange)="onChange($event)"
    nzAllowClear
    nzShowSearch
    cdkScrollable
  >
    <nz-option
      *ngFor="
        let option of commonService.dropDownMetaData[col.filterCode ?? col.name]
      "
      [nzValue]="option.Code"
      [nzLabel]="option.Label"
    ></nz-option>
  </nz-select>
</div>   
